import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { ZoneInfoDetailPage, ZoneInfoListPage } from './Pages'

const ZoneInfoRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ZoneInfoListPage />} />
        <Route path={`:authority_code`} element={<ZoneInfoDetailPage />} />
        <Route path={`create`} element={<ZoneInfoDetailPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default ZoneInfoRoot
